import { dispatchAction } from '@ardoq/rxbeach';
import { notifyPerspectivesDestroyed } from './FilterActions';
import { PerspectiveBackboneModel } from 'aqTypes';
import type { perspectives as PerspectiveBackboneModelCollection } from 'collections/perspectives';

export const backboneDispatchers = (
  Perspectives: typeof PerspectiveBackboneModelCollection
) =>
  Perspectives.on('destroy', (perspective: PerspectiveBackboneModel) => {
    dispatchAction(
      notifyPerspectivesDestroyed({
        perspectiveIds: [perspective.id],
      })
    );
  });
